import { Component } from '@angular/core';

@Component({
  templateUrl: './client-main-panel.component.html',
  styleUrls: ['./client-main-panel.component.scss'],
})
export class ClientMainPanelComponent {
  constructor() {}
}
